import FormattedMessage from 'I18n/components/FormattedMessage';
import { LeftIcon } from 'foundations-assets';
import { Link } from 'foundations-components/transitional/components/Link';
import { Flex } from 'foundations-components/components/Flex';
import { StyledUILink } from '../../styles/TextInput.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BackLink = ({
  onClick,
  href = ''
}) => {
  return /*#__PURE__*/_jsx(Flex, {
    inlineSize: "fit-content",
    children: /*#__PURE__*/_jsx(Link, {
      href: href,
      onClick: onClick,
      children: /*#__PURE__*/_jsx(StyledUILink, {
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "200",
          children: [/*#__PURE__*/_jsx(LeftIcon, {
            size: "300"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'button.back'
          })]
        })
      })
    })
  });
};